import {
  Identifiable,
  Planzone,
  ProjectElementDetailsConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateProjectElementDetailsConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: ProjectElementDetailsConfiguration,
    nextConfiguration: ProjectElementDetailsConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          projectElementDetailsConfiguration: JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateProjectElementDetailsConfiguration };
